import { yup } from '@framework/validation/initYup.ts';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { WidgetType } from '../../../Widget.ts';
import { WidgetConfigurationSlotRender } from '../../common/config-slots/WidgetConfigurationSlotRender.tsx';
import { WidgetConfigurationSlots } from '../../common/config-slots/WidgetConfigurationSlots.tsx';
import {
  CommonConfigComponent,
  CommonInputWidgetConfigSchema,
} from '../common/CommonInputConfigComponent.tsx';
import {
  DecimalSizeConfigInput,
  decimalSizeConfigSchema,
} from '../common/DecimalSizeConfigInput.tsx';
import { type INumberWidget } from './INumberWidget.ts';

export const NumberWidgetConfigSchema: yup.ObjectSchema<INumberWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.Number).required(),
    decimalSize: decimalSizeConfigSchema,
  });

export interface INumberWidgetConfigComponentProps
  extends IWidgetComponentProps<INumberWidget> {}

export function NumberWidgetConfigComponent(
  props: INumberWidgetConfigComponentProps,
) {
  return (
    <>
      <CommonConfigComponent {...props} />
      <WidgetConfigurationSlotRender
        slot={WidgetConfigurationSlots.Default}
        order={20}
      >
        <DecimalSizeConfigInput />
      </WidgetConfigurationSlotRender>
    </>
  );
}
